
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "@embroider/macros/-embroider-implicit-modules.js";
import "@glimmer/tracking/-embroider-implicit-modules.js";
import "ember-cache-primitive-polyfill/-embroider-implicit-modules.js";
